import { c as _c } from "react/compiler-runtime";
import { type ParsedUrlQuery } from 'querystring';
import { omit } from 'ramda';
import { useChangePath, useQueryString } from 'shared/components/Router';
import { makeErrorToast } from 'shared/components/Toaster';
import { type ConfigStatus } from 'shared/configStatuses';
import { HttpStatusCodes } from 'shared/httpStatus';
import OverScreen from 'shared/overScreens/niceModalReact';
import { isNilOrEmpty } from 'shared/utils';
import { DETAILED_STATUS_POPUP_TEXT } from 'shared/hooks/dagViewConstants';
import { CONFIG_ID_QUERY_PARAMETER_KEY, POPUP_QUERY_PARAMETER_KEY } from 'shared/constants';
export interface ShowDagViewProps {
  configId: number;
  configName: string;
  isActive: boolean;
  configStatus: ConfigStatus;
  useNativeDag?: boolean;
}
const showDagView = (type: DAGViewTypes, isPageWithConfigId: boolean) => (data: ShowDagViewProps): void => {
  void OverScreen.show('dagViewStatusPopup', {
    ...data,
    type,
    isPageWithConfigId
  });
};
export type DAGViewTypes = 'attributionModel' | 'reportingSolution' | 'budgetOptimiser' | 'connector';
const shouldShowDagView = (isPageWithConfigId: boolean) => (query: ParsedUrlQuery = {}): boolean => {
  return query.popup === DETAILED_STATUS_POPUP_TEXT && (isPageWithConfigId || !isNilOrEmpty(query?.configId));
};
const useDagView = (type, t0) => {
  const $ = _c(14);
  const isPageWithConfigId = t0 === undefined ? false : t0;
  const {
    changePath,
    populatedPathName
  } = useChangePath();
  const {
    query
  } = useQueryString();
  if (type === undefined) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        showDagView: _temp,
        shouldShowDagView: _temp2,
        handleConfigError: _temp3
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== isPageWithConfigId || $[2] !== type) {
    t1 = showDagView(type, isPageWithConfigId);
    $[1] = isPageWithConfigId;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isPageWithConfigId) {
    t2 = shouldShowDagView(isPageWithConfigId);
    $[4] = isPageWithConfigId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== changePath || $[7] !== populatedPathName || $[8] !== query) {
    t3 = t4 => {
      const {
        statusCode,
        notFoundMessage,
        unexpectedErrorMessage
      } = t4;
      if (statusCode === HttpStatusCodes.NOT_FOUND) {
        makeErrorToast(notFoundMessage);
      } else {
        makeErrorToast(unexpectedErrorMessage);
      }
      changePath(populatedPathName, omit([CONFIG_ID_QUERY_PARAMETER_KEY, POPUP_QUERY_PARAMETER_KEY])(query), true);
    };
    $[6] = changePath;
    $[7] = populatedPathName;
    $[8] = query;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      showDagView: t1,
      shouldShowDagView: t2,
      handleConfigError: t3
    };
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default useDagView;
function _temp() {}
function _temp2() {
  return false;
}
function _temp3() {}